import { gql } from "lib/apolloClient";

export const gradesItemFragment = {
  gradeFragment: gql`
    fragment gradeItem on Grade {
      id
      name
    }
  `,
};

export const basicStaffDetailsFragment = gql`
  fragment basicStaffDetails on Staff {
    id
    firstName
    middleName
    lastName
    preferredName
    prefix
    suffix
    pronouns
    profileImage
  }
`;
